import { CanActivateFn } from '@angular/router';
import { AuthzService } from '../auth/authz.service';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { LoggingService } from '../utils/logging.service';

export const actionLinkAccountGuard: CanActivateFn = () => {
  const authzService = inject(AuthzService);
  const auth0 = inject(AuthService);
  const loggingService = inject(LoggingService);

  const isLinkedAccount = authzService.linkAccountState;

  loggingService.log('isLinkedAccount', isLinkedAccount);
  // return of(true);
  return auth0.appState$.pipe(
    map((state) => {
      loggingService.log('state', state);
      const redirectUrl = state['callToRedirectRoute'];
      const socialProvider = state['socialProvider'];
      return redirectUrl && socialProvider;
    })
  );
  /*  return auth0.appState$.pipe(
      tap(() => loggingService.warn('check auth0 app state')),
      map(state => {
        loggingService.log('state', state)
        const redirectUrl = state['callToRedirectRoute']
        const socialProvider = state['socialProvider']
        if (redirectUrl && socialProvider) {
          return true
        } else {
          loggingService.warn('not allow')
          // return router.createUrlTree(['/link-account'])
          return true
        }
      })
    );*/
};
